import { combineReducers } from "@reduxjs/toolkit";
import notifications from "../features/notificationSlice";
import registration from "../features/registrationSlice";
import bubbleNotes from "../features/trikin/bubbleNotesSlice";
import bubble from "../features/trikin/bubbleSlice";
import { reducer as readBubble } from "../features/trikin/readBubbleSlice";

const rootReducer = combineReducers({
  registration,
  notifications,
  bubble,
  readBubble,
  bubbleNotes,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
